import { Checkbox } from "@mantine/core";
import { IconGps } from "@tabler/icons-react";

import { useInputProps } from "../hooks/useInputProps";
import { useDispatch } from "../../redux/hooks";
import { setFeature } from "../../redux/slices/generatorSlice";
import { getFeatureKey } from "../CustomInput/CustomInput.utils";

import useDeisolatedTime from "../_Modals/DeisolatedTimeModal/useDeisolatedTime";
import usePopulateCurrentData from "../hooks/usePopulateCurrentData";

interface IDefaultCheckbox {
  id: string;
  value: boolean;
  required: boolean;
  feature?: string;
  targetID?: string;
  rowIdx?: number;
  tag?: string;
  class?: string;
}

const DefaultCheckbox = ({
  id,
  value,
  required,
  feature,
  targetID,
  rowIdx,
  tag,
  class: category,
}: IDefaultCheckbox) => {
  const dispatch = useDispatch();
  const { onChange, ...inputProps } = useInputProps(id, value, required);

  useDeisolatedTime({ tag: tag, value: inputProps.value });
  const { handlePopulateCurrentData } = usePopulateCurrentData({
    tag,
    category,
    rowIndex: rowIdx,
  });
  const handleOnChange = async (e: any) => {
    const checked = e.target.checked;
    onChange(checked);
    handlePopulateCurrentData(checked);

    if (feature && feature === "autoTime" && targetID && checked) {
      const currentTime = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      dispatch(
        setFeature({
          key: getFeatureKey(targetID, rowIdx),
          feature: currentTime,
        }),
      );
    }
  };
  return (
    <Checkbox
      style={{
        display: "flex",
        justifyContent: "center",
      }}
      w={"100%"}
      icon={IconGps}
      size={"lg"}
      checked={inputProps.value}
      onChange={handleOnChange}
      {...inputProps}
    />
  );
};

export default DefaultCheckbox;
